import styles from './GuessBar.module.scss'
import classNames from "classnames";
import Button from "@/components/UI/Button/Button";
import Icon from "@/components/UI/Icon/Icon";

type Props = {
  guessList: Array<'' | 'correct' | 'incorrect'>
  guessLimit: number
  gameState: 'guessing' | 'success' | 'failure'
  setIsGuessing: (isGuessing: boolean) => void
  isGuessing: boolean
  setModalOpen: (modalOpen: boolean) => void
  setIsViewingHistory: (isViewingHistory: boolean) => void
  isViewingHistory: boolean
}

 const GuessBar = ({guessList, guessLimit, isGuessing, gameState, setIsGuessing, setModalOpen, setIsViewingHistory, isViewingHistory}: Props) => {

  const guessesRemaining = guessLimit - guessList.filter(guess => guess).length

  return (
    <>
      <div className={styles.guessMarkContainer}>
        {guessList.map((guess, i) =>
          <div key={i} className={classNames(styles.guessMark, guess ? styles[guess] : styles.unused)}/>
        )}
      </div>
      <div className={styles.guessBarContainer}>
        {gameState === 'guessing' && <span>{guessesRemaining} guesses left</span>}
        {!isViewingHistory && !isGuessing && gameState === 'guessing' && <Button onClick={() => setIsGuessing(true)}>Guess card...</Button>}
        {!isViewingHistory && isGuessing && gameState === 'guessing' && <Button onClick={() => setIsGuessing(false)} color="red">Return to card...</Button>}
        {!isViewingHistory && !isGuessing && gameState !== 'guessing' && <Button onClick={() => setModalOpen(true)}>Results</Button>}
        {!isViewingHistory && <Button className={styles.historyButton} onClick={() => setIsViewingHistory(true)}><Icon icon="history" /> </Button>}
        {isViewingHistory && <Button color="red" onClick={() => setIsViewingHistory(false)}><Icon icon="close" /> Close History</Button>}
      </div>
    </>
  )
 }

 export default GuessBar